import { createFileRoute } from "@tanstack/react-router"
import { HouseholdTab } from "./_household-tab"

export const Route = createFileRoute("/settings/household")({
  component: HouseholdTab,
})
